import {
    MgmtApi,
    type SuggestedPromptResponseModel
} from '@/customApiClients/mgmtApiClient/Api';
import useSWR from 'swr';

import { useConfig } from '@chainlit/react-client';

export type SuggestedPrompt = SuggestedPromptResponseModel;

interface UseDMSuggestedPromptsDataReturn {
    prompts: SuggestedPrompt[];
    isLoading: boolean;
    error: string | null;
}

const mgmtApi = new MgmtApi({
    baseUrl: '/mgmt',
    baseApiParams: { credentials: 'include' }
});

async function fetchSuggestedPrompts(): Promise<SuggestedPrompt[]> {
    const res = await mgmtApi.api.v1SuggestedPromptsList();
    console.log('Fetched suggested prompts:', res?.data?.data);
    return res?.data?.data || [];
}

export function useDMSuggestedPromptsData(): UseDMSuggestedPromptsDataReturn {
    const { config } = useConfig();
    const isEnabled = config?.features?.suggested_prompts_enabled === true;

    const {
        data: prompts = [],
        isLoading,
        error
    } = useSWR(isEnabled ? 'suggested-prompts' : null, fetchSuggestedPrompts, {
        dedupingInterval: 5 * 60 * 1000,
        revalidateOnFocus: false
    });

    return {
        prompts,
        isLoading,
        error: error?.message ?? null
    };
}
